










/* eslint-disable @typescript-eslint/camelcase */
import { Component, Vue } from 'vue-property-decorator'
import AppDatatable from '@core/components/AppDatatable.vue'
import { AccountStructureCommissionService, CommissionRatesDTO } from './api'
import { transaction_to_rate } from '@company-common/config/product-to-transaction-map.json'

@Component({
  components: {
    AppDatatable
  }
})
export default class UserCommissionStructure extends Vue {
  private commissionRates: CommissionRatesDTO[] = []

  get tableColumns () {
    const columns = [
      { label: 'Level', field: 'level', sortable: false },
      { label: 'Name', field: 'name', sortable: false },
      { label: 'Group', field: 'group', sortable: false }
    ]

    Object.keys(transaction_to_rate).forEach(key => {
      columns.push({
        label: key,
        field: transaction_to_rate[key],
        sortable: false
      })
    })

    return columns
  }

  get tableData () {
    return this.commissionRates.map((item, i) => {
      return {
        level: i + 1,
        name: item.name,
        group: item.group,
        ...item.commissionRates
      }
    })
  }

  get userOid () {
    return this.$router.currentRoute.params.userOid as string || this.$store.getters.currentUser.accountID
  }

  async fetchCommissionRates () {
    this.commissionRates = await AccountStructureCommissionService.getCommissionRates(this.userOid)
  }

  async mounted () {
    await this.fetchCommissionRates()
  }
}
